import type { MentionItem } from 'components/ChatInput/mentionSuggestion';
import { ContatoMencionado } from 'types';

/**
 * A menção @todos vai ao back como uma entrada comum de `contatosMencionados`
 * com `waPhoneNumberId: 'all'` e o texto leva `@all`; na exibição o bind
 * padrão troca `@all` pelo `contatoNome` ("todos").
 */
export const MENCAO_TODOS_PHONE = 'all';
export const MENCAO_TODOS_NOME = 'todos';

export const MENCAO_TODOS: ContatoMencionado = {
  contatoId: null,
  contatoNome: MENCAO_TODOS_NOME,
  waPhoneNumberId: MENCAO_TODOS_PHONE,
};

export const MENCAO_TODOS_ITEM: MentionItem = {
  id: MENCAO_TODOS_NOME,
  label: MENCAO_TODOS_NOME,
  waPhoneNumberId: MENCAO_TODOS_PHONE,
  contact: 'Mencione todos os membros do grupo',
};

export const isMencaoTodos = (waPhoneNumberId?: string | null) =>
  waPhoneNumberId === MENCAO_TODOS_PHONE;

/** Adiciona o item @todos no topo das sugestões quando a busca combina. */
export function incluirMencaoTodos(
  query: string,
  items: MentionItem[],
): MentionItem[] {
  if (!MENCAO_TODOS_NOME.startsWith(query.trim().toLowerCase())) return items;
  return [MENCAO_TODOS_ITEM, ...items];
}
